import React from 'react';
import LocationEventsTab from '../../../../../components/Locations/LocationEventsTab';
import { getLocationId } from '../../../utils/locationTransformers';

const EventsTab = ({ selectedLocation }) => (
  <LocationEventsTab locationId={getLocationId(selectedLocation)} />
);

export default EventsTab;
